import { render, staticRenderFns } from "./Pago.vue?vue&type=template&id=5ac3d309"
import script from "./Pago.vue?vue&type=script&lang=js"
export * from "./Pago.vue?vue&type=script&lang=js"
import style0 from "./Pago.vue?vue&type=style&index=0&id=5ac3d309&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports